import React from 'react'

export default function CheckedSquare(props) {
  return (
    <svg
      width={props.width ? props.width : '24'}
      height={props.height ? props.height : '24'}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M18 3H6C5.20435 3 4.44129 3.31607 3.87868 3.87868C3.31607 4.44129 3 5.20435 3 6V18C3 18.7956 3.31607 19.5587 3.87868 20.1213C4.44129 20.6839 5.20435 21 6 21H18C18.7956 21 19.5587 20.6839 20.1213 20.1213C20.6839 19.5587 21 18.7956 21 18V6C21 5.20435 20.6839 4.44129 20.1213 3.87868C19.5587 3.31607 18.7956 3 18 3ZM19 18C19 18.2652 18.8946 18.5196 18.7071 18.7071C18.5196 18.8946 18.2652 19 18 19H6C5.73478 19 5.48043 18.8946 5.29289 18.7071C5.10536 18.5196 5 18.2652 5 18V6C5 5.73478 5.10536 5.48043 5.29289 5.29289C5.48043 5.10536 5.73478 5 6 5H18C18.2652 5 18.5196 5.10536 18.7071 5.29289C18.8946 5.48043 19 5.73478 19 6V18Z'
        fill={props ? props.color : '#1D79FB'}
      />
      <path
        d='M14.6992 8.38822L10.9192 13.3882L9.28921 11.2782C9.1261 11.0687 8.88645 10.9326 8.62296 10.8997C8.35947 10.8669 8.09373 10.9401 7.88421 11.1032C7.67469 11.2663 7.53855 11.506 7.50573 11.7695C7.47291 12.033 7.5461 12.2987 7.70921 12.5082L10.1392 15.6182C10.2334 15.7374 10.3535 15.8336 10.4904 15.8994C10.6272 15.9652 10.7773 15.999 10.9292 15.9982C11.0819 15.9979 11.2325 15.9625 11.3695 15.8949C11.5064 15.8273 11.6261 15.7292 11.7192 15.6082L16.2892 9.60822C16.451 9.39605 16.5219 9.1283 16.4862 8.86387C16.4506 8.59945 16.3114 8.36001 16.0992 8.19822C15.887 8.03644 15.6193 7.96557 15.3549 8.0012C15.0904 8.03683 14.851 8.17605 14.6892 8.38822H14.6992Z'
        fill={props ? props.color : '#1D79FB'}
      />
    </svg>
  )
}
